import { z } from 'zod';

export const AlertStatusEnum = z.enum(['TRIGGERED', 'ASSIGNED', 'CLOSED', 'RESOLVED']);

export const AlertSchema = z.object({
  assignedUser: z.string().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  createdDate: z
    .string()
    .refine(
      (val) => {
        return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,3}$/.test(val);
      },
      {
        message: 'Invalid ISO date format (expected YYYY-MM-DDTHH:mm:ss.SSS)',
      }
    )
    .optional(),
  id: z.string().nullable().optional(),
  jsonData: z.string().nullable().optional(),
  lastModifiedBy: z.string().nullable().optional(),
  lastModifiedDate: z
    .string()
    .refine(
      (val) => {
        return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,3}$/.test(val);
      },
      {
        message: 'Invalid ISO date format (expected YYYY-MM-DDTHH:mm:ss.SSS)',
      }
    )
    .optional(),
  notes: z.string().nullable().optional(),
  shortDesc: z.string().nullable().optional(),
  status: AlertStatusEnum.nullable().optional(),
  triggeredAlertId: z.string(),
});
